import { IRetryPolicy, RetryContext } from "@microsoft/signalr";

class RetryPolicy implements IRetryPolicy {
  nextRetryDelayInMilliseconds(retryContext: RetryContext): number | null {
    return 10000;
  }
}

export default RetryPolicy;
